export default __webpack_public_path__ + "static/media/SAS0270.34I-39286_-25301_0.49d47b76.jpg";